import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'



//CREATE A ROLE
const submit = (payload) => client.post('roles', payload);
export const useCreateRole = (payload) => useMutation(['createRole'],() => submit(payload))